import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Line } from "./LineBlock";
import { defaultData } from "./LineDefaultData";
import { meta } from "./LineMetadata";

export const LineBlock: BlockExport = {
  type: "component",
  Block: Line,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-line",
    size: 24,
  },
  meta,
};
